// extracted by mini-css-extract-plugin
var _1 = "WFaX3ERHrDySOGWAx39U";
var _2 = "WFaX3ERHrDySOGWAx39U";
var _3 = "CMZaFjWgyWEzBfT76qhB";
export { _1 as "form-bottom-margin", _2 as "formBottomMargin", _3 as "title" }
